export const modeLabels = {
  STANDBY: "Stand By",
  SENSE_ONLY: "Sense Only",
  OPERATIONAL: "Operational",
  OFFLINE: "Offline",
  RESEARCH: "Research",
};

export const DEVICE_MODES = {
  STANDBY: { label: "Stand By", color: "#FFED90", iconName: "modeIconStandBy" },
  SENSE_ONLY: {
    label: "Sense Only",
    color: "#8FFDB0",
    iconName: "modeIconSenseOnly",
  },
  OPERATIONAL: {
    label: "Operational",
    color: "#96BEFA",
    iconName: "modeIconOperational",
  },
  RESEARCH: {
    label: "Research",
    color: "#FD8FCA",
    iconName: "modeIconResearch",
  },
  OFFLINE: { label: "Offline", color: "#BDBDBD", iconName: "modeIconOffline" },
};

export const getModeValue = (mode) => {
  switch (mode) {
    case "OFFLINE":
      return "OFFLINE";
    case "SENSE_ONLY":
      return "SENSE_ONLY";
    case "STANDBY":
      return "STANDBY";
    case "OPERATIONAL":
      return "OPERATIONAL";
    case "RESEARCH":
      return "RESEARCH";
    case "NEWLY_ONBOARDED":
      return "NEWLY_ONBOARDED";
    default:
      return "OFFLINE";
  }
};

export const getDeviceSize = () => {
  const parentWidth = document.querySelector(
    ".chorus-app-container"
  ).clientWidth;

  let itemPerRow;
  if (parentWidth > 3840) {
    itemPerRow = 9;
  } else if (parentWidth > 2560) {
    itemPerRow = 6;
  } else if (parentWidth > 1920) {
    itemPerRow = 5;
  } else if (parentWidth > 1705) {
    itemPerRow = 4;
  } else if (parentWidth > 1280) {
    itemPerRow = 3;
  } else {
    itemPerRow = 2;
  }
  let containerHeight =
    document.querySelector(".chorus-app-container").clientHeight - 225; // substract the header height from main container to get device-container height

  const selectedFiltersWrapper = document.querySelector(
    ".selectedFiltersWrapper"
  );
  if (selectedFiltersWrapper) {
    containerHeight = containerHeight - 10;
  }
  const rowsCount = Math.round(containerHeight / 240) || 2;
  // const rowsCount = Math.round(containerHeight / 270) || 2;

  const totalDeviceCount = rowsCount * itemPerRow;
  return totalDeviceCount;
};
